import { gql, useQuery } from "@apollo/client";
import {
  APIProvider,
  AdvancedMarker,
  InfoWindow,
  Map,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useCallback, useState } from "react";
import Loader from "../../../Atoms/Loader";

interface SumoMapProps {
  ids: string[];
}

export default function SumoMap({ ids }: SumoMapProps) {
  const MarkerWithInfoWindow = ({ position, infoContent }) => {
    const [markerRef, marker] = useAdvancedMarkerRef();

    const [infoWindowShown, setInfoWindowShown] = useState(true);

    const handleMarkerClick = useCallback(
      () => setInfoWindowShown((isShown) => !isShown),
      []
    );
    const handleClose = useCallback(() => setInfoWindowShown(false), []);

    return (
      <>
        <AdvancedMarker
          position={position}
          ref={markerRef}
          onClick={handleMarkerClick}
        />

        {infoWindowShown && (
          <InfoWindow
            anchor={marker}
            onCloseClick={handleClose}
            maxWidth={150}
            disableAutoPan={true}
          >
            <p>{infoContent}</p>
          </InfoWindow>
        )}
      </>
    );
  };

  const { loading, error, data } = useQuery(GET_SUMO_MAP_DATA, {
    fetchPolicy: "cache-and-network",
    ssr: false,
    variables: {
      input: {
        ids: ids,
      },
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (error || !data) {
    return <></>;
  }

  const { products } = data;
  const { records } = products;

  return (
    <div
      style={{
        marginTop: 15,
      }}
    >
      <APIProvider apiKey={process.env.GOOGLE_MAPS_API_KEY} language={"en"}>
        <Map
          style={{ height: "500px" }}
          mapId="test"
          defaultZoom={13}
          defaultCenter={records[0].meetingPlaceGoogleMapsQuery.geoLocation}
        >
          {records.map((p, index) => {
            return (
              <MarkerWithInfoWindow
                key={index}
                position={p.meetingPlaceGoogleMapsQuery.geoLocation}
                infoContent={p.translation.name}
              />
            );
          })}
        </Map>
      </APIProvider>
    </div>
  );
}

const GET_SUMO_MAP_DATA = gql`
  query ($input: ProductsInput) {
    products(input: $input) {
      records {
        translation(lang: en) {
          name
        }
        meetingPlaceGoogleMapsQuery {
          geoLocation {
            lat
            lng
          }
        }
      }
    }
  }
`;
